export type ExpiringItem<T> = {
  value: T;
  expiry: number;
};

export function setWithExpiry(key: string, value: string, ttlSeconds: number): void {
  const now = Date.now();
  const item: ExpiringItem<string> = {
    value,
    expiry: now + ttlSeconds * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key: string): string | null {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  let item: ExpiringItem<string>;
  try {
    item = JSON.parse(itemStr) as ExpiringItem<string>;
  } catch {
    localStorage.removeItem(key);
    return null;
  }

  if (typeof item?.value !== "string" || typeof item?.expiry !== "number") {
    localStorage.removeItem(key);
    return null;
  }

  const now = Date.now();
  if (now > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}